var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.detail.questions ? _vm.detail.questions.length : null
  var g1 = _vm.single.length
  var g2 = g1 > 0 ? _vm.single.length : null
  var g3 = g1 > 0 ? _vm.single.length : null
  var g4 = _vm.more.length
  var g5 = g4 > 0 ? _vm.more.length : null
  var g6 = g4 > 0 ? _vm.more.length : null
  var g7 = _vm.judge.length
  var g8 = g7 > 0 ? _vm.judge.length : null
  var g9 = g7 > 0 ? _vm.judge.length : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
        g3: g3,
        g4: g4,
        g5: g5,
        g6: g6,
        g7: g7,
        g8: g8,
        g9: g9,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }